import { lazy } from 'react'

export const FeedbackVariant1 = lazy(() => import('./FeedbackVariant1'))
